import { render, staticRenderFns } from "./read_detail.vue?vue&type=template&id=131ef6a0&"
import script from "./read_detail.vue?vue&type=script&lang=js&"
export * from "./read_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports